import React, { useEffect } from 'react';

export const PageLoader = () => {
  useEffect(() => {
    const { body } = document;

    body.classList.add('overlay-is-active');

    return () => {
      body.classList.remove('overlay-is-active');
    };
  }, []);

  return (
    <div className="PageLoader Overlay" role="progressbar" aria-label="Loading" aria-busy="true" aria-live="assertive">
      <div className="PageLoader-Spinner">
        <div className="Spinner Spinner--blue Spinner--large">
          <i /><i /><i /><i /><i /><i />
        </div>
      </div>
    </div>
  );
};
